// extracted by mini-css-extract-plugin
export var container = "index-module--container--CUZuE";
export var reviewCard = "index-module--reviewCard--qggcg";